import { SlDialog, SlIcon } from '@shoelace-style/shoelace/dist/react';
import ReturnIcon from "./ReturnIcon";
import { useAppStore } from '../stores/AppStore';

export default function AreYouSure() {
    const { showExitModal, setShowExitModal } = useAppStore(state => state);

    const handleExit = (e) => {
        e.preventDefault();
        setShowExitModal(false);
        window.location.replace('/power-up');
    }

    const handleCancel = () => {
        setShowExitModal(false);
    } 

    const handleClose = (event) => {
        if (event.target === event.currentTarget) {
            setShowExitModal(false);
        }
    }

    return (
        <SlDialog
            className="z-50 sl_dialog"
            open={showExitModal}
            modal
            noHeader={true}
            style={{ maxHeight: 'calc(100vh - 60px)', overflowY: 'auto' }}
        >
            <div> 
                <div className="text-xl font-bold flex justify-end">
                    <SlIcon name="x-lg" className="cursor-pointer" onClick={handleClose}></SlIcon>
                </div>

                <div className="text-center font-bold text-base leading-snug text-black">
                    Are you sure?
                </div>

                <div className="flex justify-center gap-x-[25px] mt-[27px] mb-8">
                    <div 
                        className="group border h-[52px] w-[140px] flex justify-center items-center border-white hover:bg-calm hover:font-semibold rounded-full cursor-pointer"
                        onClick={handleCancel}
                    >
                        Cancel
                    </div>

                    <div 
                        className="group border h-[52px] w-[140px] text-lava flex justify-center items-center border-lava hover:bg-lava hover:font-semibold hover:text-white rounded-full cursor-pointer"
                        onClick={handleExit}
                    >
                        <ReturnIcon hoverColor='white'/>
                        <div className="inline-block w-[70px] ml-2.5 text-base leading-snug text-center">
                            Exit
                        </div>
                    </div>
                </div>
            </div>
        </SlDialog>
    );
}